import { Component, EventEmitter, Input, Output } from '@angular/core';

    @Component({
      selector: 'app-debounce-button',
      templateUrl: './debounce-button.component.html',
      styleUrls: ['./debounce-button.component.scss']
    })
    export class DebounceButtonComponent {
        @Input() label: string;
        @Output() onClick = new EventEmitter<any>();
        @Input() ngClass = {};
        @Input() timer: number = -1;
        
        onClickButton(event) {
            this.onClick.emit(event);
        }
    }